import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingStateBtnComponent } from '@web/shared/ui';
import { RefreshSvgComponent } from '@uc/shared/svg';
import { LoadMoreGTMService } from '@uc/web/core';

@Component({
	selector: 'uc-course-search-load-more-btn',
	templateUrl: './course-search-load-more-btn.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, RefreshSvgComponent, LoadingStateBtnComponent],
})
export class CourseSearchLoadMoreBtnComponent {
	isLoading = input.required<boolean>();
	page = input.required<number>();
	searchTerm = input<string>();

	loadMore = output<number>();

	constructor(private _loadMoreGTMSrv: LoadMoreGTMService) {}

	onLoadMore() {
		this.loadMore.emit(Number(this.page()) + 1);
		this._loadMoreGTMSrv.loadResults(this.searchTerm() ?? '');
	}
}
